import { Card } from "../Card";
import { ISectionedHorizontalLinedTableProps } from "./SectionedHorizontalLinedTable";

export const View = (props: ISectionedHorizontalLinedTableProps) => {
  return (
    <Card noPadding className="SectionedHorizontalLinedTable">
      {props.children}
    </Card>
  );
};
